module.exports = __webpack_public_path__ + "assets/delete_disabled.aa2ae7db.svg";